import {
  ATTRIBUTE_QUALIFIER_CONTAINS,
  ATTRIBUTE_QUALIFIER_CONTAINS_TAGS,
  ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS,
  ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS_TAGS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS,
  ATTRIBUTE_QUALIFIER_HAS_TAGS,
  ATTRIBUTE_QUALIFIER_EQUAL,
  ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL,
  ATTRIBUTE_QUALIFIER_LARGER,
  ATTRIBUTE_QUALIFIER_LESS,
  ATTRIBUTE_QUALIFIER_SELECT_VALUE,
  ATTRIBUTE_QUALIFIER_HAS_LOCATIONS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS,
} from "./attributeQualifierTypes.js";

export const qualifierOptionsWithValue = [
  ATTRIBUTE_QUALIFIER_EQUAL,
  ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL,
  ATTRIBUTE_QUALIFIER_CONTAINS,
  ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS,
  ATTRIBUTE_QUALIFIER_CONTAINS_TAGS,
  ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS_TAGS,
  ATTRIBUTE_QUALIFIER_LARGER,
  ATTRIBUTE_QUALIFIER_LESS
];
export const qualifierOptionsWithSelectTags = [
  ATTRIBUTE_QUALIFIER_HAS_TAGS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS
];

export const qualifierOptionsWithSelectLocations = [
  ATTRIBUTE_QUALIFIER_HAS_LOCATIONS,
  ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS,
];

export const qualifierOptionsWithSelectValue = [
  ATTRIBUTE_QUALIFIER_SELECT_VALUE
]